module.exports = __webpack_public_path__ + "static/media/_title_18.c0e1c877.svg";